import React, { useContext } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Dashboard from "../../(Admin) dashboard/index.js";
// Import explicit file to avoid ambiguity between multiple EmployeeTable copies
import EmployeesTableadmin from "../../(admin)employeemanagement/EmployeeManagement.jsx";
import Reports from "../../(Admin) Reports/index.js";
import Attendance from "../../(Admin)Attendance/index.jsx";
import Mo3tiAdminDocumentRequests from "../../(Admin)DocumentRequests/DocumentRequestsPage.jsx";
import ExcelSalaryProcessorWithTheme from "../../(Admin and Manager) Taxcalculator/index.jsx";
import Payroll from "../../(admin and manager) Payroll/index.jsx";
import Mo3tiAdvancementManagement from "../../(Admin)AdvancementManagement/AdvancementManagementPage.jsx";
import LeaveApprovalPage from "../../(Admin)leave_Managment/index.jsx";
import EmployeeActionsPage from "../../(Admin)EmployeeActions/EmployeeActionsPage.jsx";
import Calendar from '../../(All) Calendar/index.jsx';
import EscalationGroupMapping from "../../(Admin) Escalation group mapping/index.jsx";
import GroupsManagement from "../../(user) GroupsManagement/index.jsx";
import Mo3tiSettingsPage from "../../(All) settings/index.js";
import MessengerPage from "../../(All) messenger/MessengerPage.jsx";
import PageGuard from "../../../components/PageGuard.jsx";
import { LanguageContext } from "../../../constant/LanguageContext.js";
import translations from "../constants/User_translations.js";
import { pageToModuleMap } from "../constants/navItems.js";

const AdminRoutes = ({ pageProps, isPrivateMessagingEnabled, toggleTheme }) => {
  const { language } = useContext(LanguageContext);
  const t = translations[language] || {};
  const { pathname } = useLocation();

  // This shell is mounted at /userprofile/*, /userprofileadmin/* or
  // /userprofilemanager/* — redirect hidden pages to the same shell's dashboard.
  const shellBase = `/${pathname.split("/").filter(Boolean)[0] || "userprofile"}`;

  // Wrap a route element in PageGuard using this folder's pageToModuleMap
  const guard = (page, label, element) => (
    <PageGuard
      pageKey={pageToModuleMap[page] || null}
      pageLabel={label}
      redirectTo={`${shellBase}/dashboard`}
    >
      {element}
    </PageGuard>
  );

  return (
    <Routes>
      <Route path="/" element={<Dashboard flushTop />} />
      <Route path="/dashboard" element={<Dashboard flushTop />} />
      <Route
        path="/employees"
        element={guard("employees", t.employees || "Employees", <EmployeesTableadmin />)}
      />
      <Route
        path="/attendance"
        element={guard("attendance", t.attendance || "Attendance", <Attendance />)}
      />
      <Route
        path="/reports"
        element={guard("reports", t.reports || "Reports", <Reports />)}
      />
      <Route
        path="/calendar"
        element={guard("calendar", t.calendar || "Calendar", <Calendar />)}
      />
      <Route
        path="/messages"
        element={guard(
          "messages",
          t.messages || "Messages",
          isPrivateMessagingEnabled ? (
            <MessengerPage />
          ) : (
            <Navigate to="/userprofile" replace />
          )
        )}
      />
      <Route
        path="/Mo3tiAdminDocumentRequests"
        element={guard(
          "Mo3tiAdminDocumentRequests",
          t.documents || "Documents",
          <Mo3tiAdminDocumentRequests />
        )}
      />
      <Route
        path="/LeaveApprovalPage"
        element={guard("LeaveApprovalPage", t.leave || "Leave", <LeaveApprovalPage />)}
      />
      <Route
        path="/Mo3tiAdvancementManagement"
        element={guard(
          "Mo3tiAdvancementManagement",
          t.solfa || "Solfa",
          <Mo3tiAdvancementManagement />
        )}
      />
      <Route
        path="/ChangesPage"
        element={guard(
          "ChangesPage",
          t.employeeChanges || "Employee Changes",
          <EmployeeActionsPage />
        )}
      />
      <Route
        path="/Payroll"
        element={guard("Payroll", t.payroll || "Payroll", <Payroll />)}
      />
      <Route
        path="/TaxCalculator"
        element={guard(
          "TaxCalculator",
          t.taxCalculator || "Tax Calculator",
          <ExcelSalaryProcessorWithTheme />
        )}
      />
      {/* This shell (the one promoted Admin View accounts actually land in)
          had no route for Escalation Group Mapping at all — it only ever
          existed in the separate/legacy Admin_Acount shell, so a promoted
          user could never reach it regardless of grants. "Complaints"/"My
          Escalations" is intentionally NOT here: it's a universal
          self-service page that only belongs in User View. */}
      <Route
        path="/EscalationGroupMapping"
        element={guard(
          "EscalationGroupMapping",
          t.escalationGroupMapping || "Escalation Group Mapping",
          <EscalationGroupMapping />
        )}
      />
      {/* Had no route in this shell at all — the "Groups" nav item pointed
          at a URL only UserRoutes.jsx/Mo3tiUserProfile.jsx could match, so a
          promoted Admin View account always fell through to the catch-all
          below and got bounced back to the dashboard, regardless of any
          admin-level grant. */}
      <Route
        path="/groups"
        element={guard("groups", t.groups || "Groups", <GroupsManagement />)}
      />
      <Route path="/Settings" element={<Mo3tiSettingsPage {...pageProps} toggleTheme={toggleTheme} />} />
      <Route path="*" element={<Navigate to="/userprofile" replace />} />
    </Routes>
  );
};

export default AdminRoutes;
